import script from "./CompanyMember.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyMember.vue?vue&type=script&setup=true&lang=js"

import "../../assets/css/pc/account.css?vue&type=style&index=0&id=632b21ce&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632b21ce"]])

export default __exports__